import React, { useEffect, useState } from 'react';
import RangePicker from '../../../shared/Point/Filters/RangePicker/RangePicker';
import { REPORT_FILTER_PERIODS } from '../../../../constants/defaultValues';
import { getGeneralBalance, resetGeneralBalance } from '../../../../store/actions/reports';
import { useDispatch } from 'react-redux';
import * as types from '../../../../store/actions/types';

const rangePeriod = REPORT_FILTER_PERIODS.find(period => period.key === 'range');
const initialPeriod = REPORT_FILTER_PERIODS[0];

const Filters = () => {
    const dispatch = useDispatch();

    const [selectedPeriod, setSelectedPeriod] = useState(initialPeriod);
    const [dates, setDates] = useState(Object.values(initialPeriod.getRange()));
    const [startDate, endDate] = dates;

    const getReportData = (startDate, endDate) => {
        if (startDate && endDate) {
            dispatch(getGeneralBalance(startDate, endDate));
        }
    };

    const clearDates = () => {
        setDates([null, null]);
    };

    const clearReportData = () => {
        dispatch(resetGeneralBalance());
    };

    const clearAll = () => {
        clearDates();
        clearReportData();
    };

    const onReset = () => {
        clearAll();
        setSelectedPeriod(rangePeriod);
    };

    const onPeriodChange = period => {
        clearAll();
        setSelectedPeriod(period);

        if (period.key !== rangePeriod.key) {
            const { startTime, endTime } = period.getRange();
            setDates([startTime, endTime]);
            getReportData(startTime, endTime);
        }
    };

    const handleDateChange = (date, callback) => {
        if (date) {
            clearReportData();
            setSelectedPeriod(rangePeriod);
            callback();
        }
    };

    const onStartDateChange = date => {
        handleDateChange(date, () => {
            setDates(() => [date.getTime(), endDate]);
        });
    };

    const onEndDateChange = date => {
        handleDateChange(date, () => {
            setDates(() => [startDate, date.getTime()]);
        });
    };

    useEffect(() => {
        getReportData(startDate, endDate);
    }, []);

    return (
        <div className='filters'>
            <RangePicker
                periods={REPORT_FILTER_PERIODS}
                selectedPeriod={selectedPeriod}
                onPeriodChange={onPeriodChange}
                startDate={startDate}
                endDate={endDate}
                onStartDateChange={onStartDateChange}
                onEndDateChange={onEndDateChange}
                onSearch={getReportData}
                onReset={onReset}
                showTime
            />
        </div>
    );
};

export default Filters;
